
import Header from './components/Header';

const App=()=>{
  return (
    <div>
        <Header/>
    </div>
  );
}

export default App;